import { Money, type MoneyJson } from '@chukua/common';

/** "KES 50,000" — major units, grouped. Uses Money's own rounding rule (money.ts) rather than re-deriving minor-unit factors here. */
export function formatMoney(amount: MoneyJson): string {
  const grouped = new Intl.NumberFormat('en-KE').format(Number(Money.fromJSON(amount).toDecimalString()));
  return `${amount.currency} ${grouped}`;
}
